$(document).ready(function(){
  $(".home-ticker .ticker__inner").slick({
		dots:!1,
		arrows:!1,
		infinite:!0,
		autoplaySpeed:0,
		cssEase:"linear",
		speed:5e3,
		autoplay:!0,
		slidesToShow:1,
		variableWidth:!0,
		pauseOnFocus:!1,
		pauseOnHover:!1
	})

   var ban_video = document.getElementById("banner_video");


  $(".thumbnail-img-wrap").on('click', function(){
        $(this).addClass('open');
        if($('.bloc-video').has('video')) {
           ban_video.play();
        }
        if($('.bloc-video').has('iframe')){
          $('iframe',this)[0].src += "&amp;autoplay=1";
        }
   
  })


  // accordion js..
   $(".faq-accordion-wrp li h4").on("click", (function() {
        $(this).parent().hasClass("active") ? ($(this).parent().removeClass("active"),
        $(this).siblings(".content-box").slideUp(450)) : ($(".faq-accordion-wrp li").removeClass("active"), 
        $(this).parent().addClass("active"), 
        $(".content-box").slideUp(450), 
        $(this).siblings(".content-box").slideDown(550))
    }))

  // slick slider js only for mobile....
  
mobileOnlySlider(".our-certification-row",".capsule-barand-sec .multicolumn-list", true, true, 767);
  
function mobileOnlySlider($slidername,$slidername1, $dots, $arrows, $breakpoint) {
	var slider = $($slidername);
    var slider1 = $($slidername1);
	var settings = {
		mobileFirst: true,
		dots: $dots,
		arrows: $arrows,
		responsive: [
			{
				breakpoint: $breakpoint,
				settings: "unslick"
			}
		]
	};

	slider.slick(settings);
    slider1.slick(settings);
    factorymoslider.slick(settings);

	$(window).on("resize", function () {
		if ($(window).width() > $breakpoint) {
			return;
		}
		if (!slider.hasClass("slick-initialized")) {
			return slider.slick(settings);
		}
        if (!slider1.hasClass("slick-initialized")) {
			return footerslider.slick(settings);
		}
        if (!factorymoslider.hasClass("slick-initialized")) {
			return factorymoslider.slick(settings);
		}
	});
} // Mobile Only Slider

  
})